import { render, staticRenderFns } from "./reply-comment.vue?vue&type=template&id=44f77ec4&scoped=true&"
import script from "./reply-comment.vue?vue&type=script&lang=js&"
export * from "./reply-comment.vue?vue&type=script&lang=js&"
import style0 from "./reply-comment.vue?vue&type=style&index=0&id=44f77ec4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f77ec4",
  null
  
)

export default component.exports